import { RequirementsActionType, RequirementsActionTypes } from "./requirementTypes"

export const getRequirementLab = (): RequirementsActionTypes => ({
  type: RequirementsActionType.LIST_LAB_REQUIREMENTS,
});

export const getRequirementImage = (): RequirementsActionTypes => ({
  type: RequirementsActionType.LIST_IMAGE_REQUIREMENTS,
});
